
import {BaseUser} from "../../base/contituents/user/models/BaseUser";

export class User extends BaseUser  {

}
